export default "__VITE_ASSET__f38c0f88__"